<template lang="pug">
.comentario
  .d-flex
    .text-primary {{ comentario.usuario ? comentario.usuario.nome : "" }}
    span.abbr.text-gray.pl-2 {{ comentario.realizado_em | date("DD/MM/YYYY") }}
    .label.label-rounded.ml-2(
      :class="labelClass",
      v-if="comentario.comentario_situacao && comentario.comentario_situacao.id !== 0"
    ) {{ comentario.comentario_situacao.descricao }}
  .text.pre-wrap.px-2(v-if="comentario.descricao") {{ comentario.descricao }}
  .comentario-fotos.px-2(v-if="comentario.anexos")
    .d-flex
      .foto.c-hand(
        v-for="(foto, index) in comentario.anexos",
        @click="openAnexos",
        :style="{ backgroundImage: `url(${foto.url})` }"
      )
  anexos(:active="showAnexos", :images="images", @close="closeAnexos")
</template>

<script>
import Anexos from "./Anexos.vue";

export default {
  props: { comentario: { type: Object, required: true } },
  components: { Anexos },
  data() {
    return { showAnexos: false };
  },
  methods: {
    openAnexos() {
      this.$set(this, "showAnexos", true);
    },
    closeAnexos() {
      this.$set(this, "showAnexos", false);
    },
  },
  computed: {
    images() {
      return this.comentario.anexos.map((v) => ({ src: v.url }));
    },
    labelClass() {
      switch (this.comentario.comentario_situacao.tipo) {
        case "regular":
          return "label-primary";
        case "irregular":
          return "label-error";
        case "cancelado":
          return "label-warning";
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.comentario {
  padding-bottom: 1rem;

  .foto {
    margin-right: 0.4rem;
    height: 80px;
    width: 80px;
    border-radius: 10px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .d-flex {
    align-items: flex-end;
  }

  .abbr {
    font-size: 0.6rem;
    padding-bottom: 0.1rem;
  }

  .text {
    font-weight: 200;
  }
}
</style>
